import { UserFullInfo } from "../../../api/types/UserDataTypes.js";
import { Logger } from "@ciaopeople/cp-shatsu/Logging/Logger.js";
import { UserRole } from "../../../login/UserRole.js";
import { ClientSdkPublicInterface } from "../../../sdk/ClientSdkPublicInterface.js";
import { EvaluatedActionType, PersonalDataType, SubmitPersonalDataCompletion } from "../../EvaluatedAction.js";


export function personalDataEvaluation(sdk: ClientSdkPublicInterface, logger: Logger): Promise<SubmitPersonalDataCompletion|null> {

    const session = sdk.getCurrentSession();
    if(session && session.role == UserRole.AUTHENTICATED_USER) {
        return Promise.all([
            sdk.getMe(true),
            sdk.getLastLoginProvider()
        ]).then(
            ([r, provider]) => {
                return userPersonalDataEvaluation(r.data, logger, provider);
            }
        );
    }
    else return Promise.resolve(null);
}

export function userPersonalDataEvaluation(user: UserFullInfo, logger: Logger, hintProvider: string|null = null): SubmitPersonalDataCompletion|null {
    
    const hasBirthday = user.user_info && user.user_info.birthday && user.user_info.birthday != ""?true:false;
    const hasGender = user.user_info && user.user_info.sex?true:false;
    const dataToComplete: PersonalDataType[] = [];
    if(!hasBirthday) dataToComplete.push(PersonalDataType.BIRTHDAY);
    if(!hasGender)   dataToComplete.push(PersonalDataType.GENDER);

    const submission: SubmitPersonalDataCompletion = {
        type: EvaluatedActionType.PROPOSE_PERSONAL_DATA_COMPLETION,
        data :{
            dataToComplete: [],
            hintProvider: hintProvider
        }
    };

    if(dataToComplete.length > 0) {
        logger.debug("Personal Data to complete:", dataToComplete);
        submission.data.dataToComplete.push(...dataToComplete);
        // submission = {
        //     type: EvaluatedActionType.PROPOSE_PERSONAL_DATA_COMPLETION,
        //     data: {
        //         dataToComplete: dataToComplete,
        //         hintProvider: hintProvider
        //     }
        // };
    }
    else logger.debug("No personal data to complete");
    return submission;
}